<ng-container *ngIf="isLoad$ | async">
    <button
        #buttonRef
        mat-button
        [disabled]="disabled"
        (click)="clickEvent.next($event)"
        type="button"
        class="button"
        [ngClass]="[type, height, color, borderRadius]"
        [ngStyle]="{ color: textColor }"
        tabindex="0"
    >
        <span class="toolTip" [matTooltip]="title" [matTooltipPosition]="titlePosition"> </span>
        <mat-icon
            *ngIf="icon && positionIcon === 'left'"
            [ngStyle]="{ fontSize: iconSizeRem ? iconSizeRem + 'rem' : iconSize + 'px' }"
            aria-hidden="true"
            fontSet="mdi"
            [fontIcon]="'mdi-' + icon"
        >
        </mat-icon>
        <span *ngIf="type === 'button-long'">{{ label | truncate: 50 }}</span>
        <mat-icon
            class="mdi-right"
            *ngIf="icon && positionIcon === 'right'"
            [ngStyle]="{ fontSize: iconSizeRem ? iconSizeRem + 'rem' : iconSize + 'px' }"
            aria-hidden="true"
            fontSet="mdi"
            [fontIcon]="'mdi-' + icon"
        >
        </mat-icon>
    </button>
</ng-container>
